import React, { useState, useEffect } from 'react';
import { Sun, Moon } from 'lucide-react';
import { IconButton } from '@mui/material';
import { useTheme } from '../../contexts/ThemeContext';
import { useTranslation } from 'react-i18next';

const getHeaderButtonSx = () => ({
  width: 38,
  height: 38,
  borderRadius: '50%',
  backgroundColor: 'transparent',
  color: 'var(--text-primary-color)',
  transition: 'background-color 0.2s ease',
  '&:hover': {
    backgroundColor: 'var(--hover-bg-color)',
  },
});

const getFloatingButtonSx = (themeMode) => {
  const useSecondary = themeMode === 'dark';
  const bg = useSecondary
    ? 'color-mix(in srgb, var(--portal-theme-secondary) 90%, transparent)'
    : 'color-mix(in srgb, var(--portal-theme-color) 90%, transparent)';
  const bgHover = useSecondary ? 'var(--portal-theme-secondary)' : 'var(--portal-theme-color)';
  return {
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: bg,
    color: 'var(--text-contrast-color)',
    boxShadow: '0 10px 15px -3px var(--shadow-color), 0 4px 6px -2px var(--shadow-color)',
    '&:hover': {
      backgroundColor: bgHover,
      boxShadow: '0 20px 25px -5px var(--shadow-color), 0 10px 10px -5px var(--shadow-color)',
      transform: 'scale(1.05)',
    },
    '&:active': {
      transform: 'scale(0.95)',
    },
    transition: 'all 0.2s ease',
  };
};

export default function ThemeToggle({ variant = 'header' }) {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  const isHeader = variant === 'header';
  const iconSize = 20;

  return (
    <IconButton
      onClick={toggleTheme}
      sx={isHeader ? getHeaderButtonSx() : getFloatingButtonSx(theme)}
      aria-label={t("header.toggleTheme")}
    >
      {theme === 'dark' ? (
        <Sun size={iconSize} color="currentColor" />
      ) : (
        <Moon size={iconSize} color="currentColor" />
      )}
    </IconButton>
  );
}